import { ExternalLink, FileText } from "lucide-react";
import { formatDate } from "../lib/dates";
import { triggerHaptic } from "../lib/telegram";

interface SourceBlockProps {
  title: string;
  date: string;
  url?: string;
  note?: string;
}

export function SourceBlock({ title, date, url, note }: SourceBlockProps) {
  const validUrl = Boolean(url && !url.startsWith("#"));
  return (
    <div className="source-block">
      <FileText size={20} aria-hidden="true" />
      <div className="source-block__body">
        <small>Источник</small>
        <strong>{title}</strong>
        <span>Проверено: {formatDate(date)}</span>
        {note && <p>{note}</p>}
      </div>
      {validUrl && (
        <a className="icon-button" href={url} target="_blank" rel="noreferrer" aria-label={`Открыть источник: ${title}`} onClick={() => triggerHaptic("open")}>
          <ExternalLink size={18} />
        </a>
      )}
    </div>
  );
}
